<template>
  <el-container style="height: 400px; border: 1px solid #eee">
    <el-aside width="250px" style="background-color: rgb(238, 241, 246)">
      <el-table :data="tableData" height="400" border style="width: 100%">
        <el-table-column prop="date" :label="`共${tableData.length}条数据`">
          <template slot-scope="scope">
            <el-radio
              v-model="radio"
              @change="radioChange"
              :label="scope.row.uid"
            >{{scope.row.title}}</el-radio>
            <div class="pointInfo">{{scope.row.address}}</div>
          </template>
        </el-table-column>
      </el-table>
    </el-aside>
    <el-container>
      <el-main class="mapWraper">
        <baidu-map
          ref="mapref"
          v="2.0"
          ak="pvF3bfbMR28OAbPFHPBG6Eek"
          class="bm-view"
          :center="center"
          :zoom="zoom"
          :scroll-wheel-zoom="true"
          :map-click="false"
          @ready="ready"
        >
          <bm-scale anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-scale>
          <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>
        </baidu-map>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import BaiduMap from "vue-baidu-map/components/map/Map.vue";
import BmNavigation from "vue-baidu-map/components/controls/Navigation.vue";
import BmScale from "vue-baidu-map/components/controls/Scale.vue";

/* 使用姿势
   数据
   {
     title: '',
     address: ''
   }

  模板
  <el-input placeholder="请输入地名关键字" v-model="title"></el-input>
  <el-input placeholder="请输入地名关键字" v-model="address"></el-input>
  <map-address :keyword="title" @point="(info) => {  title = info.title; address = info.address  }" />

  <cascader-address
      :provinceId.sync="formData.provinceId"
      :cityId.sync="formData.cityId"
      :areaId.sync="formData.areaId"
      :text.sync="text"
  />
*/

export default {
  name: "map-address",
  components: {
    BaiduMap,
    BmNavigation,
    BmScale
  },
  props: {
    keyword: {
      type: String
    }
  },
  data() {
    return {
      isReady: false,
      center: { lng: 109.45744048529967, lat: 36.49771311230842 },
      zoom: 13,
      radio: "",
      tableData: []
    };
  },
  // watch: {
  //   keyword: {
  //     immediate: true,
  //     handler(newV, oldV) {
  //       if (newV && this.isReady) {
  //         this.search(newV && oldV === "");
  //       }
  //     }
  //   }
  // },
  methods: {
    ready({ BMap, map }) {
      this.isReady = true;
      //this.search(true);
    },
    radioChange() {
       if (this.isReady) this.addMarker();
    },
    addMarker() {
      const uid = this.radio;
      const { BMap, map } = this.$refs.mapref;
      map.clearOverlays();
      const address = this.tableData.find(el => el.uid === uid);
      map.centerAndZoom(address.point, 13);
      const marker = new BMap.Marker(address.point);
      marker.addEventListener("click", () => {
        this.addInfo(marker, address);
        this.radio = address.uid;
      });
      map.addOverlay(marker);
      this.addInfo(marker, address);

      this.$emit("point", address);
    },
    addInfo(marker, address) {
      const html = [`<p>${address.title}</p>`, `<p>${address.address}</p>`];
      const infoWindow = new BMap.InfoWindow(html.join(""), {
        enableMessage: false,
        enableCloseOnClick: false
      });
      marker.openInfoWindow(infoWindow);
    },
    search(isInit = false) {
      if (this.tableData.find(el => el.title === this.keyword)) return;

      const { BMap, map } = this.$refs.mapref;
      const local = new BMap.LocalSearch(map, {
        pageCapacity: 20,
        onSearchComplete: e => {
          if(!e) return;
          const Ar = [];
          for (var i = 0; i < e.getCurrentNumPois(); i ++) Ar.push(e.getPoi(i));
          if (local.getStatus() == 0 && Ar && Ar.length > 0) {
            this.tableData = Ar;
            if (isInit) {
              this.radio = Ar[0].uid;
              this.addMarker();
              return
            }
            this.radio = '';
          }
        }
      });

      local.search(this.keyword);
    }
  }
};
</script>

<style scoped>
.mapWraper {
  padding: 0;
}
.bm-view {
  width: 100%;
  height: 400px;
}
.pointInfo {
  padding: 10px;
}
</style>




